import Axios from "axios";
import { SETTINGS } from "../properties/Settings";

export const GvmsRepository = {
    getAllDeclarations: async (payload) =>{
        return await Axios({
            url: SETTINGS.API_URL + `gvms`,
            method:"GET",
            params:{
                page: payload.page,
                size: payload.size,
                orderBy: payload.orderBy,
                orderDirection: payload.orderDirection,
                searchParams: payload.searchParams,
            },
        });
    },
    getById: (id) => {
        return Axios.get(`${SETTINGS.API_URL}gvms/${id}`);
    },
    createDeclaration: (data) => {
        return Axios({
            url:`${SETTINGS.API_URL}gvms`,
            method: "POST",
            data: data,
        })
    },
    deleteDeclaration: (id) => {
        return Axios({
            url: `${SETTINGS.API_URL}gvms/${id}`,
            method: "DELETE",
        
        })

    },
    updateDeclaration: (data) => {
        return Axios({
            url: `${SETTINGS.API_URL}gvms`,
            method: "PUT",
            data: data,
        });
    },
    exportToXlsx: (searchParams = "{}") => {
        return Axios({
            url: `${SETTINGS.API_URL}gvms/export`,
            method: "GET",
            params: { searchParams },
            responseType: "blob",
        });
    },
    downloadPdf: (id) =>{
        return Axios({
            url: `${SETTINGS.API_URL}gvms/${id}/pdf`,
            method: "GET",
            responseType: 'blob',
        })
    },
    getRoutes:() => {
        return Axios({
            url: `${SETTINGS.API_URL}gvms/routes`,
            method:"GET",
        });
    },
    searchForDeparturePort: (query) => {
        return Axios({
            url: `${SETTINGS.API_URL}gvms/routes/search`,
            method: "GET",
            params: {
                query: query
            },
        });
    },
    getAllPaged: (page, size) => {
        return Axios({
            url: `${SETTINGS.API_URL}gvms/routes/getPaged`,
            method: "GET",
            params: {
                page: page,
                size: size,
            },
        });
    },
    getRouteById: (id) => {
        return Axios({
            url: `${SETTINGS.API_URL}gvms/routes/${id}`,
            method: "GET",
        });
    },
    deleteFromConex: (id) => {
        return Axios({
            url: `${SETTINGS.API_URL}gvms/${id}/conex`,
            method: "DELETE",
        });
    },
    createDraftDeclaration: (data, organizationId) => {
        return Axios({
            url:`${SETTINGS.API_URL}gvms/saveDraft`,
            method: "POST",
            data: data,
            params: { organizationId },
        })
    },
    updateDraftDeclaration: (data) => {
        return Axios({
            url: `${SETTINGS.API_URL}gvms/updateDraft`,
            method: "PUT",
            data: data,
        });
    },
    setRejected: (id) =>{ 
        return Axios({
            url: `${SETTINGS.API_URL}gvms/updateRejected/${id}`,
            method: "PUT"
        });
    },
    duplicate: (consignmentId) => {
    return Axios({
      url: `${SETTINGS.API_URL}gvms/duplicate/${consignmentId}`,
      method: "POST",
    });
  },
}